/**
 * Copyright 2019-2022 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const uuidv5 = require('uuid/v5');
const Constants = require('../constants');

const VWO_NAMESPACE = uuidv5(Constants.SEED_URL, uuidv5.URL);

const UuidUtil = {
  generateFor: (userId, accountId) => {
    userId = `${userId}`; // type-cast
    const hash = `${accountId}`;
    const userIdNamespace = UuidUtil.generate(hash, VWO_NAMESPACE);
    const uuidForUserIdAccountId = UuidUtil.generate(userId, userIdNamespace);

    let desiredUuid = uuidForUserIdAccountId.replace(/-/gi, '').toUpperCase();

    return desiredUuid;
  },
  generate: (name, namespace) => {
    if (!name || !namespace) {
      return;
    }

    return uuidv5(name, namespace);
  }
};

module.exports = UuidUtil;
